"use client";

import { communitiesAdminMostPopularSchema } from "../../../../../../lib/types/schema/community/admin/communitiesAdminMostPopularSchema";
import type { UseRequestQueryProps } from "../../../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../../../request/hooks/useRequestQuery";
import { keyCommunitiesMostPopular } from "./keyCommunitiesMostPopular";

export type UseRequestCommunitiesMostPopularProps = UseRequestQueryProps & {
  id: number;
};

export const useRequestCommunitiesMostPopular = ({
  id,
  ...props
}: UseRequestCommunitiesMostPopularProps) => ({
  ...props,
  query: useRequestQuery({
    queryFnRequestProps: {
      schema: communitiesAdminMostPopularSchema,
      urlBackendPath: `/communities/${id}/stats/most-popular`,
    },
    queryKey: keyCommunitiesMostPopular({ id }),
  }),
});
